module.exports = __webpack_public_path__ + "static/media/urbangoothem01.6447f55d.webp";